'use client';

import { useState } from 'react';
import { SpotMarketConfig } from '@velocity-exchange/sdk';
import Env from 'src/environmentVariables/EnvironmentVariables';
import { useFaucetAirdrop } from 'src/hooks/velocityActions/user/useFaucetAirdrop';
import useIsMainnet from 'src/hooks/useIsMainnet';
import Button from 'src/components/primitives/Button/Button';
import { WithClassName } from 'src/utils/UtilityTypes';

const SHOW_FAUCET_BUTTON = Env.sdkEnv === 'devnet';

interface AirdropButtonProps extends WithClassName {
	spotMarket: SpotMarketConfig;
}

const AirdropButton = ({ spotMarket, className }: AirdropButtonProps) => {
	const [airdropping, setAirdropping] = useState(false);
	const { tryFaucetAirdrop } = useFaucetAirdrop();

	const handleAirdrop = async () => {
		if (airdropping) return;
		setAirdropping(true);
		await tryFaucetAirdrop(spotMarket);
		setAirdropping(false);
	};
	const isMainnet = useIsMainnet();

	if (!SHOW_FAUCET_BUTTON || isMainnet) return null;

	return (
		<Button
			size="sm"
			variant="secondary"
			onClick={handleAirdrop}
			disabled={airdropping}
			className={className}
			dataTestId="devnet-airdrop-button"
		>
			Airdrop Devnet {spotMarket.symbol}
		</Button>
	);
};

export default AirdropButton;
